/*=========================================================
REPLICA RACK
Luxury Drawer
=========================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const body = document.body;

    const drawer = document.querySelector(".rr-drawer");
    const overlay = document.querySelector(".rr-overlay");
    const burger = document.querySelector(".rr-menu-btn");
    const close = document.querySelector(".rr-close");

    const menuItems = document.querySelectorAll(".rr-nav a");
    const secondaryLinks = document.querySelectorAll(".rr-links a");
    const socialLinks = document.querySelectorAll(".rr-bottom a");

    if (!drawer || !overlay || !burger) {
        console.warn("Replica Rack Drawer: Elements missing.");
        return;
    }

    /*------------------------------------------
    OPEN
    ------------------------------------------*/

    function openDrawer() {

        body.classList.add("rr-open");
        body.style.overflow = "hidden";

        animateItems();

    }

    /*------------------------------------------
    CLOSE
    ------------------------------------------*/

    function closeDrawer() {

        body.classList.remove("rr-open");
        body.style.overflow = "";

        resetItems();

    }

    /*------------------------------------------
    ANIMATE LINKS
    ------------------------------------------*/

    function animateItems() {

        const allItems = [
            ...menuItems,
            ...secondaryLinks,
            ...socialLinks
        ];

        allItems.forEach((item, index) => {

            item.style.transition =
                "opacity .5s ease, transform .5s ease";

            item.style.transitionDelay =
                `${0.08 + index * 0.05}s`;

            item.style.opacity = "1";
            item.style.transform = "translateX(0)";

        });

    }

    /*------------------------------------------
    RESET
    ------------------------------------------*/

    function resetItems() {

        const allItems = [
            ...menuItems,
            ...secondaryLinks,
            ...socialLinks
        ];

        allItems.forEach(item => {

            item.style.opacity = "0";
            item.style.transform = "translateX(-30px)";
            item.style.transitionDelay = "0s";

        });

    }

    resetItems();

    /*------------------------------------------
    EVENTS
    ------------------------------------------*/

    burger.addEventListener("click", e => {

        e.preventDefault();
        e.stopPropagation();

        openDrawer();

    });

    close?.addEventListener("click", closeDrawer);

    overlay.addEventListener("click", closeDrawer);

    document.addEventListener("keydown", e => {

        if (e.key === "Escape") {
            closeDrawer();
        }

    });

});
if (window.lucide) {
    lucide.createIcons();
}